<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >format_list_numbered</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.cityMergeTool' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      </div>
      <!-- / SEARCH -->

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <div class="event-cantons">
        @for (city of cities; track city.id) {
          <div class="cities">
            <mat-card appearance="outlined">
              <div class="city">
                @if (city.flag) {
                  <div class="image"><img [src]="getImage(city.flag)"></div>
                }
                @if (!city.flag) {
                  <div class="no-image"><img [src]="'assets/images/district.svg'"></div>
                }
                <div style="margin: 0 10px">
                  <div class="name">{{city.name}}</div>
                  <mat-slide-toggle [checked]="arrayOfCity.includes(city.id.toString())"
                  (change)="toggle($event, city.id)"></mat-slide-toggle>
                </div>
              </div>
            </mat-card>
          </div>
        }
      </div>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>

